// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import BusTabs from "../AllTabs/BusTabs";
// import { Link } from "react-router-dom";
// import moment from "moment";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   RiCalendarLine,
//   RiSearchLine,
//   RiRefreshLine,
//   RiInformationLine,
// } from "react-icons/ri";
// import "./BusBookingList.css";

// // Custom Date Input Component
// const CustomDateInput = React.forwardRef(
//   ({ value, onClick, placeholder }, ref) => (
//     <div className="input-group input-group-sm">
//       <input
//         type="text"
//         className="form-control form-control-sm"
//         value={value}
//         onClick={onClick}
//         ref={ref}
//         readOnly
//         placeholder={placeholder}
//         style={{ fontSize: "0.8125rem" }}
//       />
//       <button
//         className="btn btn-outline-secondary btn-sm"
//         type="button"
//         onClick={onClick}
//       >
//         <RiCalendarLine />
//       </button>
//     </div>
//   )
// );

// const BusBookings = () => {
//   const { user } = useAuth();
//   const [lists, setLists] = useState([]);
//   const [filteredLists, setFilteredLists] = useState([]);
//   const [pageLoading, setPageLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Filter states with current month dates by default
//   const currentDate = new Date();
//   const firstDayOfMonth = new Date(
//     currentDate.getFullYear(),
//     currentDate.getMonth(),
//     1
//   );
//   const lastDayOfMonth = new Date(
//     currentDate.getFullYear(),
//     currentDate.getMonth() + 1,
//     0
//   );

//   const [filters, setFilters] = useState({
//     bookingNo: "",
//     pnr: "",
//     passengerName: "",
//     fromDate: firstDayOfMonth,
//     toDate: lastDayOfMonth,
//     sourceCity: "",
//     destinationCity: "",
//     bookingStatus: "",
//     paymentStatus: "",
//   });

//   // Function to calculate total fare breakdown from database
//   const calculateFareBreakdown = (booking) => {
//     try {
//       // First try to get from seat details
//       if (booking.seatDetails) {
//         const seatDetails = JSON.parse(booking.seatDetails || "[]");
//         if (Array.isArray(seatDetails) && seatDetails.length > 0) {
//           const totalBusFare = seatDetails.reduce(
//             (sum, seat) => sum + (parseFloat(seat.BusTotal) || 0),
//             0
//           );
//           const totalConvenienceFee = seatDetails.reduce(
//             (sum, seat) => sum + (parseFloat(seat.ConvenienceFee) || 100),
//             0
//           );
//           const totalFare = totalBusFare + totalConvenienceFee;

//           return {
//             busFare: totalBusFare,
//             convenienceFee: totalConvenienceFee,
//             total: totalFare,
//             passengerCount: seatDetails.length,
//             perSeatBusFare: seatDetails[0]?.BusTotal || 0,
//             perSeatConvFee: seatDetails[0]?.ConvenienceFee || 100,
//           };
//         }
//       }

//       // If seat details not available, try passenger details
//       if (booking.passengerDetails) {
//         const passengerDetails = JSON.parse(booking.passengerDetails || "[]");
//         if (Array.isArray(passengerDetails) && passengerDetails.length > 0) {
//           const totalBusFare = passengerDetails.reduce(
//             (sum, passenger) =>
//               sum + (parseFloat(passenger.TotalFareWithTaxes) || 0),
//             0
//           );
//           const passengerCount = passengerDetails.length;
//           const totalConvenienceFee = passengerCount * 100; // ₹100 per seat
//           const totalFare = totalBusFare + totalConvenienceFee;

//           return {
//             busFare: totalBusFare,
//             convenienceFee: totalConvenienceFee,
//             total: totalFare,
//             passengerCount: passengerCount,
//             perSeatBusFare: passengerDetails[0]?.TotalFareWithTaxes || 0,
//             perSeatConvFee: 100,
//           };
//         }
//       }

//       // Fallback to booking table fields
//       return {
//         busFare: booking.baseFare || booking.totalFare || 0,
//         convenienceFee:
//           booking.convenienceFee || (booking.noOfPassengers || 1) * 100,
//         total:
//           booking.totalPrice ||
//           (booking.totalFare || 0) + (booking.convenienceFee || 0),
//         passengerCount: booking.noOfPassengers || 1,
//         perSeatBusFare:
//           (booking.baseFare || booking.totalFare || 0) /
//           (booking.noOfPassengers || 1),
//         perSeatConvFee: 100,
//       };
//     } catch (e) {
//       console.error("Error calculating fare breakdown:", e);
//       // Return default values
//       const passengerCount = booking.noOfPassengers || 1;
//       return {
//         busFare: booking.baseFare || 0,
//         convenienceFee: passengerCount * 100,
//         total: (booking.baseFare || 0) + passengerCount * 100,
//         passengerCount: passengerCount,
//         perSeatBusFare: (booking.baseFare || 0) / passengerCount,
//         perSeatConvFee: 100,
//       };
//     }
//   };

//   // Initialize with user's company ID
//   useEffect(() => {
//     if (user?.cid) {
//       fetchBookings();
//     }
//   }, [user?.cid]);

//   const fetchBookings = async () => {
//     setPageLoading(true);
//     setError(null);

//     try {
//       // Build filter request with UserId
//       const filterRequest = {
//         UserId: user.id, // Add UserId to the request
//         PassengerName: filters.passengerName || "",
//         FromDate: filters.fromDate
//           ? moment(filters.fromDate).format("YYYY-MM-DD")
//           : "",
//         ToDate: filters.toDate
//           ? moment(filters.toDate).format("YYYY-MM-DD")
//           : "",
//         SourceCity: filters.sourceCity || "",
//         DestinationCity: filters.destinationCity || "",
//         BookingStatus: filters.bookingStatus || "",
//         PaymentStatus: filters.paymentStatus || "",
//         BookingNo: filters.bookingNo || "",
//         PNR: filters.pnr || "",
//         PageNumber: 1,
//         PageSize: 1000,
//       };

//       console.log("Sending filter request:", filterRequest); // Debug log

//       const response = await apiService.post(
//         config.GETBUSBOOKINGS,
//         filterRequest
//       );

//       console.log("API Response:", response); // Debug log

//       if (response && Array.isArray(response)) {
//         setLists(response);
//         setFilteredLists(response);
//       } else {
//         setLists([]);
//         setFilteredLists([]);
//       }
//     } catch (err) {
//       console.error(
//         "Fetch bookings error details:",
//         err.response?.data || err.message
//       );
//       setError("Failed to fetch bookings. Please try again.");
//     } finally {
//       setPageLoading(false);
//     }
//   };
//   const applyFilters = () => {
//     let filtered = [...lists];

//     // Apply filters
//     if (filters.bookingNo) {
//       filtered = filtered.filter((b) =>
//         b.bookingNo?.toLowerCase().includes(filters.bookingNo.toLowerCase())
//       );
//     }

//     if (filters.pnr) {
//       filtered = filtered.filter((b) =>
//         b.pnr?.toLowerCase().includes(filters.pnr.toLowerCase())
//       );
//     }

//     if (filters.passengerName) {
//       filtered = filtered.filter((b) =>
//         b.passengerName
//           ?.toLowerCase()
//           .includes(filters.passengerName.toLowerCase())
//       );
//     }

//     if (filters.fromDate) {
//       filtered = filtered.filter((b) =>
//         moment(b.bookingDate).isSameOrAfter(filters.fromDate, "day")
//       );
//     }

//     if (filters.toDate) {
//       filtered = filtered.filter((b) =>
//         moment(b.bookingDate).isSameOrBefore(filters.toDate, "day")
//       );
//     }

//     if (filters.sourceCity) {
//       filtered = filtered.filter((b) =>
//         b.sourceCity?.toLowerCase().includes(filters.sourceCity.toLowerCase())
//       );
//     }

//     if (filters.destinationCity) {
//       filtered = filtered.filter((b) =>
//         b.destinationCity
//           ?.toLowerCase()
//           .includes(filters.destinationCity.toLowerCase())
//       );
//     }

//     if (filters.bookingStatus) {
//       filtered = filtered.filter(
//         (b) => b.bookingStatus === filters.bookingStatus
//       );
//     }

//     if (filters.paymentStatus) {
//       filtered = filtered.filter(
//         (b) => b.paymentStatus === filters.paymentStatus
//       );
//     }

//     setFilteredLists(filtered);
//   };

//   const handleFilterChange = (field, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSearch = () => {
//     fetchBookings();
//   };

//   const handleReset = () => {
//     setFilters({
//       bookingNo: "",
//       pnr: "",
//       passengerName: "",
//       fromDate: firstDayOfMonth,
//       toDate: lastDayOfMonth,
//       sourceCity: "",
//       destinationCity: "",
//       bookingStatus: "",
//       paymentStatus: "",
//     });
//     fetchBookings();
//   };

//   const getStatusBadge = (status) => {
//     const statusMap = {
//       CONFIRMED: "bg-success",
//       PENDING: "bg-warning",
//       CANCELLED: "bg-danger",
//       FAILED: "bg-secondary",
//       BOOKED: "bg-info",
//       HOLD: "bg-secondary",
//     };
//     return statusMap[status] || "bg-secondary";
//   };

//   const getPaymentStatusBadge = (status) => {
//     const statusMap = {
//       SUCCESS: "bg-success",
//       PENDING: "bg-warning",
//       FAILED: "bg-danger",
//       REFUNDED: "bg-info",
//     };
//     return statusMap[status] || "bg-secondary";
//   };

//   const formatCurrency = (amount) => {
//     const num = parseFloat(amount) || 0;
//     return `INR${Math.round(num).toLocaleString("en-IN")}`;
//   };

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="col-xl-12">
//               <div className="card">
//                 <div className="p-2">
//                   <BusTabs pageName="BOOKINGLIST" />
//                 </div>

//                 {/* Simplified Filters Section */}
//                 <div className="card-body border-bottom">
//                   <div className="row g-2 align-items-end">
//                     {/* Calendar Section - Shows current month by default */}
//                     <div className="col-md-3">
//                       <label className="form-label small">From Date</label>
//                       <DatePicker
//                         selected={filters.fromDate}
//                         onChange={(date) =>
//                           handleFilterChange("fromDate", date)
//                         }
//                         customInput={<CustomDateInput placeholder="From" />}
//                         dateFormat="dd-MMM-yy"
//                         showYearDropdown
//                         showMonthDropdown
//                         dropdownMode="select"
//                         maxDate={new Date()}
//                         yearDropdownItemNumber={50}
//                         scrollableYearDropdown
//                         className="form-control form-control-sm"
//                       />
//                     </div>

//                     <div className="col-md-3">
//                       <label className="form-label small">To Date</label>
//                       <DatePicker
//                         selected={filters.toDate}
//                         onChange={(date) => handleFilterChange("toDate", date)}
//                         customInput={<CustomDateInput placeholder="To" />}
//                         dateFormat="dd-MMM-yy"
//                         showYearDropdown
//                         showMonthDropdown
//                         dropdownMode="select"
//                         maxDate={new Date()}
//                         yearDropdownItemNumber={50}
//                         scrollableYearDropdown
//                         className="form-control form-control-sm"
//                       />
//                     </div>

//                     {/* Quick Search Fields */}
//                     <div className="col-md-2">
//                       <label className="form-label small">Booking No</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         placeholder="Bkng No"
//                         value={filters.bookingNo}
//                         onChange={(e) =>
//                           handleFilterChange("bookingNo", e.target.value)
//                         }
//                         style={{ fontSize: "0.8125rem" }}
//                       />
//                     </div>

//                     <div className="col-md-2">
//                       <label className="form-label small">PNR</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         placeholder="PNR"
//                         value={filters.pnr}
//                         onChange={(e) =>
//                           handleFilterChange("pnr", e.target.value)
//                         }
//                         style={{ fontSize: "0.8125rem" }}
//                       />
//                     </div>

//                     {/* Passenger Name */}
//                     <div className="col-md-2">
//                       <label className="form-label small">Passenger</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         placeholder="Name"
//                         value={filters.passengerName}
//                         onChange={(e) =>
//                           handleFilterChange("passengerName", e.target.value)
//                         }
//                         style={{ fontSize: "0.8125rem" }}
//                       />
//                     </div>

//                     {/* Route */}
//                     <div className="col-md-3">
//                       <label className="form-label small">Route</label>
//                       <div className="row g-1">
//                         <div className="col">
//                           <input
//                             type="text"
//                             className="form-control form-control-sm"
//                             placeholder="From"
//                             value={filters.sourceCity}
//                             onChange={(e) =>
//                               handleFilterChange("sourceCity", e.target.value)
//                             }
//                             style={{ fontSize: "0.8125rem" }}
//                           />
//                         </div>
//                         <div className="col">
//                           <input
//                             type="text"
//                             className="form-control form-control-sm"
//                             placeholder="To"
//                             value={filters.destinationCity}
//                             onChange={(e) =>
//                               handleFilterChange(
//                                 "destinationCity",
//                                 e.target.value
//                               )
//                             }
//                             style={{ fontSize: "0.8125rem" }}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Status Dropdown */}
//                     <div className="col-md-2">
//                       <label className="form-label small">Status</label>
//                       <select
//                         className="form-select form-select-sm"
//                         value={filters.bookingStatus}
//                         onChange={(e) =>
//                           handleFilterChange("bookingStatus", e.target.value)
//                         }
//                         style={{ fontSize: "0.8125rem" }}
//                       >
//                         <option value="">All</option>
//                         <option value="CONFIRMED">Confirmed</option>
//                         <option value="PENDING">Pending</option>
//                         <option value="CANCELLED">Cancelled</option>
//                         <option value="BOOKED">Booked</option>
//                         <option value="HOLD">Hold</option>
//                       </select>
//                     </div>

//                     {/* Payment Dropdown */}
//                     <div className="col-md-2">
//                       <label className="form-label small">Payment</label>
//                       <select
//                         className="form-select form-select-sm"
//                         value={filters.paymentStatus}
//                         onChange={(e) =>
//                           handleFilterChange("paymentStatus", e.target.value)
//                         }
//                         style={{ fontSize: "0.8125rem" }}
//                       >
//                         <option value="">All</option>
//                         <option value="SUCCESS">Success</option>
//                         <option value="PENDING">Pending</option>
//                         <option value="FAILED">Failed</option>
//                       </select>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="col-md-2">
//                       <div className="d-flex gap-2">
//                         <button
//                           className="btn btn-primary btn-sm w-50 d-flex align-items-center justify-content-center gap-1"
//                           onClick={handleSearch}
//                           disabled={pageLoading}
//                           style={{
//                             fontSize: "0.8125rem",
//                             height: "calc(1.8125rem + 2px)",
//                           }}
//                         >
//                           <RiSearchLine />
//                           Search
//                         </button>
//                         <button
//                           className="btn btn-danger btn-sm w-50 d-flex align-items-center justify-content-center gap-1"
//                           onClick={handleReset}
//                           style={{
//                             fontSize: "0.8125rem",
//                             height: "calc(1.8125rem + 2px)",
//                           }}
//                         >
//                           <RiRefreshLine />
//                           Reset
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Bookings Table */}
//                 <div className="card-body">
//                   <div className="table-responsive table-card p-2">
//                     <table className="table align-middle" id="busBookingTable">
//                       <thead className="bg-soft-success bg-gradient">
//                         <tr>
//                           <th style={{ width: "40px" }}>S.No</th>
//                           <th>Booking No</th>
//                           <th>Route</th>
//                           <th>Journey</th>
//                           <th>Passenger</th>
//                           <th>Booking Status</th>
//                           <th>Payment Status</th>
//                           <th>Amount</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       {pageLoading === true ? (
//                         <tbody className="list form-check-all text-center">
//                           <tr>
//                             <td colSpan={10}>
//                               <img
//                                 src="/assets/images/loader.webp"
//                                 width={"64px"}
//                                 height={"64px"}
//                                 alt="Loading"
//                               />
//                               Loading, Please wait...
//                             </td>
//                           </tr>
//                         </tbody>
//                       ) : error ? (
//                         <tbody className="list form-check-all text-center">
//                           <tr>
//                             <td colSpan={10}>
//                               <div className="alert alert-danger mb-0">
//                                 {error}
//                               </div>
//                             </td>
//                           </tr>
//                         </tbody>
//                       ) : filteredLists.length === 0 ? (
//                         <tbody className="list form-check-all text-center">
//                           <tr>
//                             <td colSpan={10}>
//                               <div className="text-center py-4">
//                                 <div className="avatar-md mx-auto mb-4">
//                                   <div className="avatar-title bg-soft-primary text-primary rounded-circle fs-24">
//                                     <i className="ri-bus-line"></i>
//                                   </div>
//                                 </div>
//                                 <h5>No Bus Bookings Found</h5>
//                                 <p className="text-muted mb-0">
//                                   {Object.values(filters).some(
//                                     (f) => f && typeof f !== "object"
//                                   )
//                                     ? "Try adjusting your filters"
//                                     : "No bookings available for the selected period"}
//                                 </p>
//                               </div>
//                             </td>
//                           </tr>
//                         </tbody>
//                       ) : (
//                         <tbody className="list form-check-all">
//                           {filteredLists.map((v, index) => {
//                             const fareBreakdown = calculateFareBreakdown(v);

//                             return (
//                               <tr key={v.busBookingId}>
//                                 <td>{index + 1}</td>
//                                 <td>
//                                   <div className="fw-semibold small">
//                                     {v.bookingNo}
//                                   </div>
//                                   <small className="text-muted d-block">
//                                     PNR: {v.pnr || "N/A"}
//                                   </small>
//                                   <small className="text-muted">
//                                     {moment(v.bookingDate).format("DD-MMM-YY")}
//                                   </small>
//                                 </td>
//                                 <td>
//                                   <div className="fw-semibold small">
//                                     {v.sourceCity} → {v.destinationCity}
//                                   </div>
//                                   <small className="text-muted">
//                                     {moment(v.departureDate).format(
//                                       "DD-MMM-YY"
//                                     )}
//                                   </small>
//                                 </td>
//                                 <td>
//                                   <div className="small">
//                                     {v.journeyType || "One Way"}
//                                   </div>
//                                   <small className="text-muted">
//                                     {v.boardingPoint && v.droppingPoint && (
//                                       <>
//                                         {v.boardingPoint.substring(0, 15)}... →{" "}
//                                         {v.droppingPoint.substring(0, 15)}...
//                                       </>
//                                     )}
//                                   </small>
//                                 </td>
//                                 <td>
//                                   <div className="fw-semibold small">
//                                     {v.passengerName}
//                                   </div>
//                                   <small className="text-muted">
//                                     {fareBreakdown.passengerCount} Passenger(s)
//                                   </small>
//                                 </td>
//                                 <td>
//                                   <span
//                                     className={`badge ${getStatusBadge(
//                                       v.bookingStatus
//                                     )}`}
//                                   >
//                                     {v.bookingStatus}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <span
//                                     className={`badge ${getPaymentStatusBadge(
//                                       v.paymentStatus
//                                     )}`}
//                                   >
//                                     {v.paymentStatus}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   {/* Total Amount Display */}
//                                   <div className="fw-semibold text-primary">
//                                     {formatCurrency(fareBreakdown.total)}
//                                   </div>

//                                   {/* Fare Breakdown Tooltip/Hover Info */}
//                                   {/* <div className="small text-muted">
//                                     <div className="d-flex align-items-center gap-1">
//                                       <RiInformationLine
//                                         className="text-info"
//                                         size={12}
//                                       />
//                                       <span>Includes:</span>
//                                     </div>
//                                     <div className="ps-2">
//                                       <div className="d-flex justify-content-between">
//                                         <span>Bus Fare:</span>
//                                         <span>
//                                           {formatCurrency(
//                                             fareBreakdown.busFare
//                                           )}
//                                         </span>
//                                       </div>
//                                       <div className="d-flex justify-content-between">
//                                         <span>Conv. Fee:</span>
//                                         <span>
//                                           {formatCurrency(
//                                             fareBreakdown.convenienceFee
//                                           )}
//                                         </span>
//                                       </div>
//                                       {fareBreakdown.passengerCount > 1 && (
//                                         <div className="mt-1 small">
//                                           <em>
//                                             ({fareBreakdown.passengerCount} ×{" "}
//                                             {formatCurrency(
//                                               fareBreakdown.perSeatBusFare +
//                                                 fareBreakdown.perSeatConvFee
//                                             )}
//                                             )
//                                           </em>
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div> */}
//                                 </td>
//                                 <td>
//                                   <ul className="list-inline hstack gap-1 mb-0">
//                                     <li className="list-inline-item">
//                                       <Link
//                                         to={`/bus/booking/${v.busBookingId}`}
//                                         className="btn btn-sm btn-primary"
//                                         style={{
//                                           padding: "0.25rem 0.5rem",
//                                           fontSize: "0.75rem",
//                                         }}
//                                       >
//                                         VIEW
//                                       </Link>
//                                     </li>
//                                   </ul>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       )}
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BusBookings;


import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import BusTabs from "../AllTabs/BusTabs";
import moment from "moment";
const BusBookings = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const GetData = async (pageNumber) => {
    setPageLoading(true);
    const res = await apiService.post(
      `${config.GETUSERBUSBOOKINGS}/${user?.id}`,
      pageSize,
      pageNumber
    );
    console.log(res);
    setLists(res);
    setPageLoading(false);
  };
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <BusTabs pageName="BOOKINGLIST" />
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                            <th>S No</th>
                                    <th>Booking No</th>
                                    <th>PNR</th>
                                    <th>Passenger</th>
                                    <th>Route</th>
                                    
                                    <th>Departure Date</th>
                                    <th>Booking Status</th>
                                    <th>Payment Status</th>
                                    <th>Total Price</th>
                                    <th>Action</th>
                        </tr>
                      </thead>
                      {pageLoading === true ? (
                        <tbody className="list form-check-all text-center">
                          <tr>
                            <td colSpan={9}>
                              <img
                                src="/assets/images/loader.webp"
                                width={"64px"}
                                height={"64px"}
                              ></img>
                              Loading, Please wait...
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody className="list form-check-all">
                          {lists.length > 0 &&
                            lists.map((v, index) => (
                              <tr key={v.busBookingId}>
                                <td>{index + 1}</td>
                                <td>{v.bookingNo}</td>
                                <td>{v.pnr}</td>
                                <td>{v.passengerName}</td>
                                <td>{v.sourceCity}-{v.destinationCity}</td>
                                <td>
                                  {moment(v.departureDate).format("DD MMM YY")}
                                </td>
                                <td>
                                  {v.bookingStatus === "CONFIRMED" ? (
                                    <span className="badge bg-success">
                                      CONFIRMED
                                    </span>
                                  ) : (
                                    <span className="badge bg-warning">
                                      {v.bookingStatus}
                                    </span>
                                  )}
                                </td>
                                <td>
                                  {v.paymentStatus === "SUCCESS" ? (
                                    <span className="badge bg-success">
                                      SUCCESS
                                    </span>
                                  ) : (
                                    <span className="badge bg-warning">
                                      {v.paymentStatus}
                                    </span>
                                  )}
                                </td>
                                <td>{v.totalPrice} INR</td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li className="list-inline-item">
                                      <Link
                                        to={`/bus/booking/${v.busBookingId}`}
                                        className="btn btn-sm btn-primary"
                                      >
                                        VIEW
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusBookings;
